import React from 'react';
import { FormattedDate, type FormatDateOptions } from 'react-intl';

import useSettings from '../hooks/useSettings';
import { parseDate } from '../Utils';
import SquareChip from '../SquareChip';

interface DateSquareChipProps {
	value?: number;
	format?: Pick<FormatDateOptions, 'year' | 'month' | 'day' | 'hour' | 'minute' | 'second'>;
}

export default function DateSquareChip(props: DateSquareChipProps) {
	const { t } = useSettings();

	return (
		<SquareChip
			label={
				props.value ? (
					<FormattedDate value={parseDate(props.value)?.toDate()} {...props.format} />
				) : (
					t('VIEW_ITEM_NO_DATE')
				)
			}
			disabled={!props.value}
		/>
	);
}
